export default __webpack_public_path__ + "static/media/pictogramBeaconStandardVehicle128.e5c37086.svg";